import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { arrayToObjectByField } from "Utils";
import { OnlineStatusesData } from "Utils/webSocketUtils";

interface VehiclesStateData {
  data: VehiclesStateDataItem | null;
}

const initialState: VehiclesStateData = {
  data: null,
};

export const Slice = createSlice({
  name: "vehiclesState",
  initialState,
  reducers: {
    resetVehicleStateData: () => initialState,
    updateVehiclesStateData: (state, action) => {
      state.data = action.payload;
      return state;
    },
    setVehiclesStateData: (state, action) => {
      state.data = arrayToObjectByField(action.payload, "vehicle_id");
      return state;
    },
    updateVehicleOnlineStatuses: (
      state,
      action: PayloadAction<OnlineStatusesData>
    ) => {
      if (!state.data) return state;

      const onlineStatuses = action.payload;
      for (const vehicleId of Object.keys(onlineStatuses)) {
        if (state.data[vehicleId]) {
          const statusData = onlineStatuses[vehicleId];
          state.data[vehicleId] = {
            ...state.data[vehicleId],
            online_status: statusData.online_status,
            last_contact: statusData.last_contact,
            seconds_until_offline: statusData.seconds_until_offline,
          };
        }
      }
      return state;
    },
  },
});

export default Slice;
